// extracted by mini-css-extract-plugin
module.exports = {"composeErrors":"ComposeErrors__composeErrors__LFpq9"};